import { snakeCase } from 'lodash';
export var ExpenseEvents = /*#__PURE__*/ function(ExpenseEvents) {
    ExpenseEvents["ExpenseCreate"] = "expense_create";
    ExpenseEvents["ExpenseUpdate"] = "expense_update";
    ExpenseEvents["ExpenseDelete"] = "expense_delete";
    return ExpenseEvents;
}({});
export const ExpenseEventsMap = Object.keys(ExpenseEvents).reduce((acc, key)=>{
    acc[snakeCase(key).toUpperCase()] = ExpenseEvents[key];
    return acc;
}, {});
